const HeaderImg = {
    Logo: require("./Icon.png"),
    more:require('./more.png')
};
const Hro = {
    HeroImage: require("./hero-img.png"),
};
const ButtonIcons = {
    Download: require('./download.png'),
    PlayW: require('./play white.png'),
    Meta: require('./metamask.png'),
    Form: require('./open-form.png'),

}
const WhyUto = {
    im1: require('./why1.png'),
    im2:require('./why2.png'),
    im3:require('./why3.png'),
}
const Proto = {
    p1: require('./prto1.png'),
    p2:require('./proto2.png'),
    p3: require('./proto3.png'),
    p4:require('./proto4.png'),
}
const PartnerLogos = {
    Muon: require("./muon.png"),
    Brightid: require("./brightid.png"),
    NewPerspectivellc: require("./4_webp.webp"),
    ReadPlayer: require("./readPlayer.png"),
};
const DownloadLogos = {
    p1: require('./Vector.png'),
    p2:require('./Vector-1.png'),
    p3: require('./Vector-2.png'),
    p1_b: require('./win-1.png'),
    p2_b:require('./ios-1.png'),
    p3_b: require('./and-1.png'),
    d_img:require('./download-area-img.png')
}
export{
    HeaderImg,
    Hro,
    ButtonIcons,
    WhyUto,
    Proto,
    PartnerLogos,
    DownloadLogos
}